import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import router from './routes';
import { store } from './store/store';
import { Provider } from 'react-redux'
import ErrorBoundary from './components/ErrorBoundary';

import { HelmetProvider } from 'react-helmet-async';

// The previous `window.store = store` global was used by 11 imperative call sites that
// needed `state.location.selected.code` outside the React tree. They now import a small
// helper (`utils/getSelectedStoreCode`) which reads the store directly via ES modules.
// Removing the global keeps the boundary clean and avoids polluting `window`.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <HelmetProvider>
          <RouterProvider router={router}/>
        </HelmetProvider>
      </Provider>
    </ErrorBoundary>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
